export const SHORT_CODE_EXPIRATION_MINUTES = 5;
